// Is there a draft waiting for admin to release to the client? The server
// decides (backend/app/draft_gate.py) and attaches `awaiting_release` to every
// project row and doc. Three panels show the Approve & Send button off this one
// answer. The fallback is the pre-2026-09-11 expression, kept only for a payload
// that predates the field (a cached tab across a deploy); on the per-version
// model that expression shows the button after a client asks for revisions with
// nothing new uploaded, which is the bug this replaced.
export function awaitingRelease(project) {
  if (!project) return false;
  if (typeof project.awaiting_release === 'boolean') return project.awaiting_release;
  return project.draft_approved !== true && (project.editor_status_id || 0) >= 2 && (project.admin_status_id || 0) >= 5;
}
